/**
 * PATH: packages/email-hub/src/feature/components/filter-sidebar/SenderSection.tsx
 * FILE_ID: EMAILHUB-FILTERSIDEBAR-SENDER-001
 * PURPOSE: Renders sender text and top-sender filters.
 */
import { Search, X } from 'lucide-react'

import type { EmailFacets } from '../../hooks/useEmails'
import { SectionHeader } from './SidebarChrome'
import type { SectionProps } from './types'

interface SenderSectionProps extends SectionProps {
  facets: EmailFacets | null
  value: string
  onChange: (value: string) => void
}

export function SenderSection({
  expanded,
  onToggle,
  facets,
  value,
  onChange,
}: SenderSectionProps) {
  const senders = (facets?.senders || []).slice(0, 12)
  return (
    <div className="mb-3">
      <SectionHeader
        label="Sender"
        expanded={expanded}
        onToggle={onToggle}
        count={value ? 1 : 0}
      />
      {expanded && (
        <div className="space-y-1">
          <div className="relative">
            <Search className="absolute left-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-muted-foreground" />
            <input
              type="text"
              placeholder="contains…  (e.g. acme.com)"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="w-full text-xs pl-6 pr-6 py-1 border border-border rounded bg-background text-foreground"
            />
            {value && (
              <button
                onClick={() => onChange('')}
                className="absolute right-1 top-1/2 -translate-y-1/2 p-0.5 hover:bg-accent rounded"
              >
                <X className="h-2.5 w-2.5 text-muted-foreground" />
              </button>
            )}
          </div>
          {senders.length > 0 && (
            <div className="space-y-px">
              <p className="text-[9px] uppercase tracking-wider text-muted-foreground/70 px-1 mt-1">
                Top senders
              </p>
              {senders.map((s) => (
                <button
                  key={s.from_address}
                  onClick={() => onChange(s.from_address)}
                  className="w-full text-left px-2 py-0.5 text-[11px] text-muted-foreground hover:bg-accent rounded flex items-center justify-between"
                  title={s.from_address}
                >
                  <span className="truncate flex-1">
                    {s.from_name || s.from_address}
                  </span>
                  <span className="text-[9px] tabular-nums opacity-70 ml-1">
                    {s.count}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
